import { guideItems } from "@/mocks/content";

export default function Guide() {
  return (
    <section id="guide" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8 text-center md:mb-12">
        <p className="mb-2 text-xs font-medium uppercase tracking-widest text-accent-600">Sweet Guide</p>
        <h2 className="font-display text-3xl text-foreground-950 md:text-5xl">吃瓜百科 · 甜蜜指南</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
          第一次吃瓜也别担心，从入门到资深，这几招帮你甜得明白、甜得安心。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {guideItems.map((g, i) => (
          <div
            key={g.id}
            className="group relative overflow-hidden rounded-2xl bg-background-100 p-6 transition-colors hover:bg-accent-100"
          >
            <span className="absolute -right-3 -top-4 font-display text-7xl text-background-200 transition-colors group-hover:text-accent-200">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className="relative">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-white text-2xl text-primary-500 shadow-[0_1px_0_0_oklch(var(--background-200))]">
                <i className={g.icon}></i>
              </div>
              <h3 className="mb-2 text-base font-bold text-foreground-900">{g.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{g.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}